import React, {useRef} from "react";
import {useNavigate} from "react-router-dom";
import "./RolesSection.css";
import {trackEvent} from "../../analytics/posthog";
import {useTrackOnView} from "../../analytics/useTrackOnView";

const RolesSection = () => {
    const navigate = useNavigate();
    const sectionRef = useRef<HTMLElement>(null);
    useTrackOnView(sectionRef, 'landing_roles_section_viewed', {section_name: 'roles'});

    return (
        <section ref={sectionRef} className="bg-[#f2f2f2] py-20 roles-bg">
            <div className="container text-center mb-12">
        <span className="text-xs bg-primary/10 text-[#1677ff] px-3 py-3">
          Who you are
        </span>
                <h2 className="text-3xl font-medium mt-3">Choose your role</h2>
                <p className="text-gray-500">
                    Promotify connects businesses, promoters and partners in one transparent pay-per-click marketplace.
                </p>
            </div>

            <div className="container grid md:grid-cols-3 gap-10 items-start">
                <button
                    type="button"
                    className="role-trap left role-trap-button"
                    onClick={() => {
                        trackEvent('landing_advertiser_role_card_clicked', {
                            selected_role: 'advertiser',
                            destination: '/advertiser-guide'
                        });
                        navigate('/advertiser-guide');
                    }}
                    aria-label="Explore Advertiser"
                >
                    <img
                        src="assets/images/roles-section/advertiser-icon.svg"
                        className="mx-auto mb-6 w-40 h-auto"
                        alt="Advertiser"
                    />
                    <h3 className="text-xl font-semibold">Advertiser</h3>
                    <p className="text-gray-600 mt-3">
                        Launch campaigns and pay only for tracked clicks.
                    </p>
                </button>
                <button
                    type="button"
                    className="role-trap mid role-trap-button"
                    onClick={() => {
                        trackEvent('landing_promoter_role_card_clicked', {
                            selected_role: 'promoter',
                            destination: '/promoter-guide'
                        });
                        navigate('/promoter-guide');
                    }}
                    aria-label="Explore Promoter"
                >
                    <h3 className="text-xl font-semibold">Promoter</h3>
                    <p className="text-gray-600 mt-3">
                        Pick campaigns, share your link, earn per click.
                    </p>
                    <img
                src="assets/images/roles-section/promoter-icon.svg"
                className="mx-auto mb-6 w-40 h-auto"
                alt="Promoter"
                />
                </button>
                <button
                    type="button"
                    className="role-trap right role-trap-button"
                    onClick={() => {
                        trackEvent('landing_partner_role_card_clicked', {
                            selected_role: 'partner',
                            destination: '/partner-guide'
                        });
                        navigate('/partner-guide');
                    }}
                    aria-label="Explore Partner"
                >
                    <img
                        src="assets/images/roles-section/partner-icon.svg"
                        className="mx-auto mb-6 w-40 h-auto"
                        alt="Partner"
                    />
                    <h3 className="text-xl font-semibold">Partner</h3>
                    <p className="text-gray-600 mt-3">
                        Invite users, earn recurring commission — plus advertiser spend.
                    </p>
                </button>
            </div>
        </section>
    );
};

export default RolesSection;
